module.exports = __webpack_public_path__ + "static/media/menu_dropdown_black.1bd8b575.svg";